import { gql } from '@apollo/client';
/**
 * @fragment MediaFragment
 * @since 1.0.0
 */
export const MediaFragment = gql `
  fragment MediaFragment on Media {
    id
    url
    filename
    filesize
    mimetype
    date
    thumbnail
    thumbnailWidth
    thumbnailHeight
    display
    displayWidth
    createdAt
    updatedAt

    attributes {
      id
      type
      data
      createdAt
      updatedAt
    }
  }
`;
